/**
 * @generated SignedSource<<4b3868785d10ad3a7b926a2bc67bbdb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Storecast_storecast$data = {
  readonly id: string;
  readonly name: string;
  readonly widgets: ReadonlyArray<{
    readonly __typename: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AllWidgets_widget" | "useWidgetToPos_widget">;
  }>;
  readonly " $fragmentType": "Storecast_storecast";
};
export type Storecast_storecast$key = {
  readonly " $data"?: Storecast_storecast$data;
  readonly " $fragmentSpreads": FragmentRefs<"Storecast_storecast">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Storecast_storecast",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "widgets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useWidgetToPos_widget"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AllWidgets_widget"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};
})();

(node as any).hash = "9ff9ee820d2f45e8446180b64c1cdf4c";

export default node;
